import { render, staticRenderFns } from "./ItemsServices.vue?vue&type=template&id=3c78b945&scoped=true&"
import script from "./ItemsServices.vue?vue&type=script&lang=js&"
export * from "./ItemsServices.vue?vue&type=script&lang=js&"
import style0 from "./ItemsServices.vue?vue&type=style&index=0&id=3c78b945&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c78b945",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3c78b945')) {
      api.createRecord('3c78b945', component.options)
    } else {
      api.reload('3c78b945', component.options)
    }
    module.hot.accept("./ItemsServices.vue?vue&type=template&id=3c78b945&scoped=true&", function () {
      api.rerender('3c78b945', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/tenders/view/ItemsServices.vue"
export default component.exports